
export class Constants {
	// static currencyList = {
	// 	doller:{
	// 		sign:'$',
	// 		name:'دلار',
	// 		field:'doller',
	// 	},
	// 	toman:{
	// 		sign:	'ت',
	// 		name:'تومان',
	// 		field:'toman',
	// 	}
	// };

	static APP_NAME = "_BITBITE_";

	static SERVER_IP_PORT = process.env.REACT_APP_SERVER_IP_PORT;
	static DEVELOPMENT_MODE = process.env.REACT_APP_DEVELOPMENT_MODE;

	static API_URL = Constants?.DEVELOPMENT_MODE ? ("http://" + Constants?.SERVER_IP_PORT + "/api/") : "/api/";

	static UPLOAD_SERVER = { localServer: true, url: Constants?.API_URL + 'upload' };
	// static LoginAppService = 'BitbiteAppService';

	// static API_URL_SEARCH_PERSON	= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/searchperson", type:'GET'};
	// static API_URL_REGISTER = {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/register", type:'POST'};
	// static API_URL_REGISTER_PERSON			= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/register-person", type:'POST'};
	// static API_URL_REGISTER_NEW_USER			= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/register-new-user", type:'POST'};
	// static API_URL_REGISTER_USER			= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/register-user", type:'POST'};
	// static API_URL_VERIFY			= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/verify", type:'POST'};

	// static API_URL_SET_PROFILE_PICTURE			= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/setprofilepicture", type:'PUT'};
	// static API_URL_LOGIN 							= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/login", type:'POST'};
	// static API_URL_GOOGLE_AUTH						= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/google-auth", type:'POST'};
	// static API_URL_LOGIN_OTP						= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/loginotp", type:'POST'};
	// static API_URL_RESEND_CODE = {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/resend-password", type:'POST'};
	// static API_URL_SEARCH_PERSON					= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/searchperson", type:'GET'};
	// static API_URL_PASSWORD_SET	= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/set-password", type:'PUT'};
	// static API_URL_PROFILE_SET	= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/set-profile", type:'PUT'};
	// static API_URL_PROFILE_GET	= {name:["Bitbite", "Project"], url:Constants?.API_URL + "bitbiteappservice/get-profile", type:'PUT'};
	// static API_URL_FRANO_SET_BUSINESS_SERVICE_ACCESS = {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/set-business-service-access", type:'PUT'};
	// static API_URL_FRANO_ACCESS_ADD	= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/add-access", type:'PUT'};
	// static API_URL_FRANO_ACCESS_REMOVE	= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/remove-access", type:'PUT'};
	// static API_URL_FRANO_PERSON_DELETE	= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/remove-person", type:'POST'};
	// static API_URL_FRANO_GET_USER_ACCESS_LIST	= {name:"Bitbite", url:Constants?.API_URL + "bitbiteappservice/get-user-access-list", type:'GET'};

	// static API_URL_CONFIG_PREPARE_EDIT			= {name:['Bitbite', 'Project'], url:Constants?.API_URL + "bitbiteappservice/prepare-config", type:'GET'};
	// static API_URL_CONFIG_SET		= {name:['Bitbite', 'Project'], url:Constants?.API_URL + "bitbiteappservice/set-config", type:'PUT'};
	// static API_URL_CAPTCHA		= {name:['Bitbite'], url:Constants?.API_URL + "bitbiteappservice/captcha", type:'PUT'};


	static LOADER_COLOR = '#17B2E7';
	static Jet_LOADER_COLOR = 'primary';

	static LANGUAGE_INDEX = 0;
	static tokens = [];

	static LANGUAGES = [{
		dateName: 'SHAMSI',
		lang: 'fa',
		htmlDir: 'rtl',
		img: 'ir.svg',
		dateFormat: "jYYYY/jMM/jDD",
		dateFormatStr: "jDD jMMMM jYYYY",
		dateTimeFormat: "jYYYY/jMM/jDD HH:mm",
		dateTimeFormat2: "HH:mm jYYYY/jMM/jDD",
		dateTimeFormatShort: "jYY/jMM/jDD HH:mm",
		dateTimeFormatShort2: "HH:mm jYY/jMM/jDD",
		dateFullTimeFormat: "jYYYY/jMM/jDD HH:mm a",
		dateFullTimeFormatStr: "jDD jMMMM jYYYY HH:mm a",
		monthName: "jMMMM jYYYY",
		monthField: "jMonth",
		monthFieldSmall: "jmonth",
		weekDays: ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'],
		appName: 'سامانه نوآوری فرانو',
	}, {
		dateName: 'MILADY',
		lang: 'en',
		htmlDir: 'ltr',
		img: 'us.svg',
		dateFormat: "MM/DD/YYYY",
		dateFormatStr: "YYYY MMMM DD",
		dateFormatStr2: "DD MMMM YYYY",
		dateTimeFormatStr: "MM/DD/YYYY HH:mm",
		dateTimeFormatShort: "MM/DD/YY HH:mm",
		dateFullTimeFormat: "MM/DD/YYYY HH:mm",
		dateFullTimeFormatStr: "YYYY MMMM DD HH:mm",
		monthName: "MMMM YYYY",
		monthField: "month",
		monthFieldSmall: "month",
		weekDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
		appName: 'Bitbite System',
	}];
	static ACTIVE_LANGUAGE = Constants?.LANGUAGES[Constants?.LANGUAGE_INDEX];
	static SYSTEM_ID = "BITBITE";

	static GENERAL_FLOOR = -101;
	static DIFFERENT = -100;
	static FLOOR_MINUS_2 = -2;
	static UNDERGROUND_FLOOR = -1;
	static GROUND_LEVEL = 0;

	static SEARCH_FIELDS_COMMON = ['address', 'owner', 'ownerTel', 'submitDateFrom', 'submitDateTo', 'dateFrom', 'dateTo', 'first', 'count', 'active', 'archive', 'sources', 'marked', 'mine', 'sortBy', 'presentation', '_id', 'sortTime', 'bitbite', 'explain', 'public', 'leadCode', 'desc', 'archiveLabel', 'jetLeadLabels'];

	static SEARCH_FIELDS = {
		'ALL_ITEMS': ['eTypes', 'eType', 'dTypes', 'dType', 'areas', 'totalFrom', 'totalTo', 'meterFrom', 'meterTo', 'advanceSale', 'rahnFrom', 'rahnTo', 'rentFrom', 'rentTo', 'canExchange', 'exchange', 'autoChange', 'sizeSubsFrom', 'sizeSubsTo', 'ageFrom', 'ageTo', 'mainFacilities', 'rooms', 'floorFrom', 'floorTo', 'floorUnitFrom', 'floorUnitTo', 'facilities'].concat(Constants.SEARCH_FIELDS_COMMON),
		'APARTMENT': ['eTypes', 'eType', 'dTypes', 'dType', 'areas', 'totalFrom', 'totalTo', 'meterFrom', 'meterTo', 'advanceSale', 'rahnFrom', 'rahnTo', 'rentFrom', 'rentTo', 'canExchange', 'exchange', 'autoChange', 'sizeSubsFrom', 'sizeSubsTo', 'ageFrom', 'ageTo', 'mainFacilities', 'rooms', 'floorFrom', 'floorTo', 'floorUnitFrom', 'floorUnitTo', 'facilities'].concat(Constants.SEARCH_FIELDS_COMMON),
		'VILA': ['eTypes', 'eType', 'dTypes', 'dType', 'areas', 'totalFrom', 'totalTo', 'meterFrom', 'meterTo', 'advanceSale', 'rahnFrom', 'rahnTo', 'rentFrom', 'rentTo', 'canExchange', 'exchange', 'autoChange', 'sizeSubsFrom', 'sizeSubsTo', 'sizeFrom', 'sizeTo', 'ageFrom', 'ageTo', 'mainFacilities', 'rooms', 'floorFrom', 'floorTo', 'facilities'].concat(Constants.SEARCH_FIELDS_COMMON),
		'APARTMENT_VILA': ['eTypes', 'eType', 'dTypes', 'dType', 'areas', 'totalFrom', 'totalTo', 'meterFrom', 'meterTo', 'advanceSale', 'rahnFrom', 'rahnTo', 'rentFrom', 'rentTo', 'canExchange', 'exchange', 'autoChange', 'sizeSubsFrom', 'sizeSubsTo', 'ageFrom', 'ageTo', 'mainFacilities', 'rooms', 'floorFrom', 'floorTo', 'floorUnitFrom', 'floorUnitTo', 'facilities'].concat(Constants.SEARCH_FIELDS_COMMON),
		'EDARI': ['eTypes', 'eType', 'dTypes', 'dType', 'areas', 'totalFrom', 'totalTo', 'meterFrom', 'meterTo', 'advanceSale', 'rahnFrom', 'rahnTo', 'rentFrom', 'rentTo', 'canExchange', 'exchange', 'autoChange', 'sizeSubsFrom', 'sizeSubsTo', 'ageFrom', 'ageTo', 'mainFacilities', 'rooms', 'floorFrom', 'floorTo', 'sanad', 'facilities', 'officeRoom'].concat(Constants.SEARCH_FIELDS_COMMON),
		'MAGHAZE_TEJARI': ['eTypes', 'eType', 'dTypes', 'dType', 'areas', 'totalFrom', 'totalTo', 'meterFrom', 'meterTo', 'advanceSale', 'rahnFrom', 'rahnTo', 'rentFrom', 'rentTo', 'canExchange', 'exchange', 'autoChange', 'sizeSubsFrom', 'sizeSubsTo', 'barFrom', 'barTo', 'mainFacilities', 'transfer', 'floorFrom', 'floorTo', 'sanad', 'facilities'].concat(Constants.SEARCH_FIELDS_COMMON),
		'MOSTAGHELAT': ['eTypes', 'eType', 'dTypes', 'dType', 'areas', 'totalFrom', 'totalTo', 'meterFrom', 'meterTo', 'advanceSale', 'rahnFrom', 'rahnTo', 'rentFrom', 'rentTo', 'canExchange', 'exchange', 'autoChange', 'sizeSubsFrom', 'sizeSubsTo', 'sizeFrom', 'sizeTo', 'ageFrom', 'ageTo', 'mainFacilities', 'sanad', 'facilities'].concat(Constants.SEARCH_FIELDS_COMMON),
		'ZAMIN_KOLANGI': ['eTypes', 'eType', 'dTypes', 'dType', 'areas', 'totalFrom', 'totalTo', 'meterFrom', 'meterTo', 'rahnFrom', 'rahnTo', 'rentFrom', 'rentTo', 'canExchange', 'exchange', 'autoChange', 'sizeFrom', 'sizeTo', 'direction', 'barFrom', 'barTo', 'sanad', 'usage', 'facilities'].concat(Constants.SEARCH_FIELDS_COMMON),
		'ZAMIN': ['eTypes', 'eType', 'dTypes', 'dType', 'areas', 'totalFrom', 'totalTo', 'meterFrom', 'meterTo', 'rahnFrom', 'rahnTo', 'rentFrom', 'rentTo', 'canExchange', 'exchange', 'autoChange', 'sizeFrom', 'sizeTo', 'direction', 'barFrom', 'barTo', 'sanad', 'usage', 'facilities'].concat(Constants.SEARCH_FIELDS_COMMON),
		'KOLANGI': ['eTypes', 'eType', 'dTypes', 'dType', 'areas', 'totalFrom', 'totalTo', 'meterFrom', 'meterTo', 'rahnFrom', 'rahnTo', 'rentFrom', 'rentTo', 'canExchange', 'exchange', 'autoChange', 'sizeFrom', 'sizeTo', 'direction', 'barFrom', 'barTo', 'sanad', 'usage', 'facilities'].concat(Constants.SEARCH_FIELDS_COMMON),
		'SALE_OR_EXCHANGE': ['rahn', 'rent', 'autoChange'],
		'SALE': ['rahn', 'rent', 'autoChange'],
		'ADVANCE_SALE': ['rahn', 'rent', 'autoChange'],
		'MORTGAGE_RENT': ['total', 'meter', 'canExchange', 'exchange', 'advanceSale'],
		'FULL_RENT': ['total', 'meter', 'canExchange', 'exchange', 'advanceSale', 'autoChange', 'rahn'],
		'FULL_MORTGAGE': ['total', 'meter', 'canExchange', 'exchange', 'advanceSale', 'autoChange', 'rent'],
		'MOSTAGHELAT_MORTGAGE_RENT': ['size', 'sanad'],
		'MOSTAGHELAT_FULL_MORTGAGE': ['size', 'sanad'],
		'MAGHAZE_TEJARI_MORTGAGE_RENT': ['sanad', 'transfer'],
		'MAGHAZE_TEJARI_FULL_MORTGAGE': ['sanad', 'transfer'],
		'VILA_FULL_MORTGAGE': ['sizeFrom', 'sizeTo'],
		'VILA_MORTGAGE_RENT': ['sizeFrom', 'sizeTo'],
	}
}
